import React from 'react'
import { HomeOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';
import { Button, message, Steps, Breadcrumb, Descriptions, PageHeader } from 'antd';
import { useState } from 'react';
//import BasicInfo from '../components/registration/BasicInfo';

import BasicregWithCollapse from '../../components/registration/BasicregWithCollapse';
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb';
import BasicInfo from '../../components/registration/BasicInfo';
import { Link } from 'react-router-dom';

const { Step } = Steps;
const steps = [
  {
    title: 'Personal Info',
    content: <BasicInfo />,
  },
  {
    title: 'Upload Profile',
    content: 'Second-content',
  },

];


const Registration = () => {

  return (
    <div className='inside-main-content'>

      <AdminBreadCrumb />





      <div className="box-style" >


        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Registration"
          subTitle=""
          extra={[
            <Link to={`/member-list/`} key="reg_list">
              <Button key="1" shape='round' className='custom-button-white'> List</Button>
            </Link>

           
          ]}
        >

        </PageHeader>
        <BasicregWithCollapse />



      </div>







    </div>
  )
}

export default Registration